module.exports = __webpack_public_path__ + "img/第3章_2-4_孔廟謎題圖_3.jpg";